import { Button } from '@mui/material';
import { Modal2 } from '@niaratech/niara-react-components';
import React from 'react';
import { MdBugReport } from 'react-icons/md';
import styled from 'styled-components';
const Container = styled.div`
  position: absolute;
  z-index: 1000;
  width: 0;
  > button.open-debug-button {
    left: -12px;
    top: -12px;
    transition: opacity 0.2s;
    opacity: 0.1;
    min-width: 0;
    padding: 0;
    width: '24px';
    height: '24px';

    &:hover {
      opacity: 0.8;
    }
  }
`;
const IS_DEBUG_ENABLED = window?.['NIARA_DEBUG_ENABLED'] && true || location?.hash?.indexOf('NIARA_DEBUG_ENABLED') > 0 && true || process.env.NODE_ENV == 'development' || process.env.DEV_OR_HOMOLOG_OR_PROD == 'dev' || process.env.DEV_OR_HOMOLOG_OR_PROD == 'homolog' || false;
export type DebugButtonProps<E> = React.PropsWithChildren & {
  value: E;
  title?: string;
  displayBlock?: boolean;
};
const DebugButton: React.FC<DebugButtonProps<any>> = ({
  value,
  title,
  children,
  displayBlock
}) => {
  const [showModal, setShowModal] = React.useState(() => false);
  React.useEffect(() => {
    if (showModal || displayBlock) {
      navigator.clipboard.writeText(typeof value == 'object' ? JSON.stringify(value, null, 2) : value);
    }
  }, [showModal, displayBlock, value]);
  if (!IS_DEBUG_ENABLED) return null;
  const renderValue = () => <>
      <h2>{title}</h2>
      <pre style={{
      whiteSpace: 'pre'
    }}>{JSON.stringify(value, null, 2)}</pre>
    </>;
  if (displayBlock) {
    return renderValue();
  }
  return <Container>
      <Button className="open-debug-button" title={`Click to copy to clipboard ${title ?? ''}`} type="button" variant="text" size="small" color="error" onClick={() => {
      setShowModal(true);
    }}>
        <MdBugReport />
      </Button>
      <Modal2 show={showModal} setShow={setShowModal} render={({
      hide
    }) => {
      if (children) {
        return <>
                <Button type="button" variant="contained" onClick={hide} sx={{
            position: 'fixed',
            right: '40px',
            bottom: '40px'
          }}>
                  Fechar Modal
                </Button>
                <div style={{
            padding: '10px',
            maxWidth: '400px'
          }}>{children}</div>
              </>;
      }
      if (value && typeof value == 'object') {
        return <>
                <Button type="button" variant="contained" onClick={hide} sx={{
            position: 'fixed',
            right: '40px',
            bottom: '40px'
          }}>
                  Fechar Modal
                </Button>
                {renderValue()}
              </>;
      }
    }} />
    </Container>;
};
export default DebugButton;